import React, { Component } from 'react';
// import Button from './components/button/Button';
import QuizLanding from './components/quiz/QuizLanding';
import Quiz from './components/quiz/Quiz';
import './App.css';

class App extends Component {
	constructor() {
		super();
		this.state = { openModal: true, startQuiz: false };
	}
	openModal = () => {
		this.setState({ openModal: !this.state.openModal });
	};
	startQuiz = () => {
		this.setState({ startQuiz: !this.state.startQuiz });
	};

	componentDidMount = async () => {
		console.log('Last Update: 9.30.21 - 3.40');
	};

	render() {
		// console.log(this.state);
		return (
			<div>
				{/* ONLY Button is rendered till clicked */}
				{/* <Button onClick={() => this.openModal()} label="Discover Your R.Q." />
				{this.state.openModal && ( */}
				{/* // This is all static html/css for modal */}

				<div className="calculator-background">
					<div className="calculator-content">
						<div className="calculator-close" title="Close Window">
							{/* <span
									className="calculator-close__logo"
									onClick={this.openModal}>
									&times;
								</span> */}
						</div>
						<header className="page-header">
							<div className="page-header__logo-container">
								{/* <img
									className="page-header__logo"
									src="https://cdn.filestackcontent.com/3hjHIsgTQgCXiIxybSHB"
									alt="CreativeOne-logo"
								/> */}
							</div>
						</header>
						{/* Renders the Landing when modal initially opens. Renders Quiz when 'startQuiz' button is clicked*/}
						{!this.state.startQuiz && (
							<QuizLanding onClick={() => this.startQuiz()} />
						)}
						{this.state.startQuiz && <Quiz />}
					</div>
				</div>
				{/* )} */}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js